__turbopack_context__.v({
  "blockTable": "BlockTables-module-scss-module__TgPbpq__blockTable",
  "column": "BlockTables-module-scss-module__TgPbpq__column",
  "contents": "BlockTables-module-scss-module__TgPbpq__contents",
  "contentsWrapper": "BlockTables-module-scss-module__TgPbpq__contentsWrapper",
  "fixed": "BlockTables-module-scss-module__TgPbpq__fixed",
  "full": "BlockTables-module-scss-module__TgPbpq__full",
  "hasTitle": "BlockTables-module-scss-module__TgPbpq__hasTitle",
  "outerContents": "BlockTables-module-scss-module__TgPbpq__outerContents",
  "scrollRightButton": "BlockTables-module-scss-module__TgPbpq__scrollRightButton",
  "titles": "BlockTables-module-scss-module__TgPbpq__titles",
});
